import { render } from "./Adm_commonFooter.vue?vue&type=template&id=0eeb6fe0"
import script from "./Adm_commonFooter.vue?vue&type=script&lang=js"
export * from "./Adm_commonFooter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__